import React, { useEffect, useState } from 'react'
import { array, bool, number, string } from 'prop-types'
import { FlexDatesRoundTripGrid } from '@pcln/fly-ui-components'
import { getQualifiedFlexDates as getGridDates } from '../../components/FlexDatesRoundTrip/getQualifiedFlexDates'

export const FlexDatesRoundTripGridWrapper = ({
  showRoundTripGrid,
  minRetailPrice,
  travelDate,
  returnDate,
  calendarPricing,
}) => {
  const [data, setData] = useState(null)
  useEffect(() => {
    if (showRoundTripGrid) {
      const res = getGridDates(
        minRetailPrice,
        calendarPricing,
        travelDate,
        returnDate,
        44,
        true
      )
      setData(res)
    }
  }, [minRetailPrice, calendarPricing, showRoundTripGrid])

  return (
    !!showRoundTripGrid &&
    data?.length > 0 && (
      <FlexDatesRoundTripGrid
        dates={data}
        minimumRetailPrice={minRetailPrice}
        travelDate={travelDate}
        returnDate={returnDate}
        isSlimDesign={false}
        url={window.location.href}
      />
    )
  )
}

// Proptypes
FlexDatesRoundTripGridWrapper.propTypes = {
  showRoundTripGrid: bool,
  dates: array,
  travelDate: string,
  returnDate: string,
  calendarPricing: array,
  minRetailPrice: number,
  url: string,
}
